import { useCallback, useState } from "react";

import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

import Astuces_logement_performant from "../../../assets/pdf/Astuces_logement_performant.pdf";
import Calendrier_de_la_loi_climat_et_resilience from "../../../assets/pdf/Calendrier_de_la_loi_climat_et_résilience.pdf";
import Conseils_d_entretien from "../../../assets/pdf/Conseils_d_entretien.pdf";
import Consignes_depart_locataire_DWELL from "../../../assets/pdf/Consignes_départ_locataire_DWELL.pdf";
import EDL_Loi_ALUR_2014 from "../../../assets/pdf/EDL_Loi_ALUR_2014.pdf";
import KIT_Gel_des_loyers from "../../../assets/pdf/KIT_Gel_des_loyers.pdf";
import LE_KIT_POUR_LES_LOCATAIRES from "../../../assets/pdf/LE_KIT_POUR_LES_LOCATAIRES.pdf";
import Livre_blanc_EDL_dwell from "../../../assets/pdf/Livre_blanc_EDL_dwell.pdf";

interface IInfos {
  label: string;
  icon: string;
  pdf: string;
}
const infos: IInfos[] = [
  {
    label: "Astuces logement performance",
    icon: "bi-building-up",
    pdf: Astuces_logement_performant,
  },
  {
    label: "Calendrier de la loi climat et résilience",
    icon: "bi-thermometer-sun",
    pdf: Calendrier_de_la_loi_climat_et_resilience,
  },
  {
    label: "Conseils d'entretien",
    icon: "bi-stars",
    pdf: Conseils_d_entretien,
  },
  {
    label: "Consignes de depart locataire DWELL",
    icon: "bi-escape",
    pdf: Consignes_depart_locataire_DWELL,
  },
  {
    label: "EDL Loi ALUR 2014",
    icon: "bi-journal-bookmark-fill",
    pdf: EDL_Loi_ALUR_2014,
  },
  {
    label: "KIT Gel des loyers",
    icon: "bi-asterisk",
    pdf: KIT_Gel_des_loyers,
  },
  {
    label: "Le KIT pour les locataires",
    icon: "bi-people",
    pdf: LE_KIT_POUR_LES_LOCATAIRES,
  },
  {
    label: "Livre blanc EDL dwell",
    icon: "bi-book-half",
    pdf: Livre_blanc_EDL_dwell,
  },
];

const InfotekContainer = () => {
  const [info, setInfo] = useState<IInfos | undefined>();
  const isDesktop = useCallback(
    () =>
      !/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(
        navigator.userAgent,
      ) &&
      !/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        navigator.userAgent,
      ),
    [],
  );
  const handleClose = () => setInfo(undefined);

  return (
    <div className="bg-container">
      <h1
        className="mt-3 fw-bold mb-4"
        style={{ fontSize: "24px", color: "#000D5B" }}
      >
        Infothèque
      </h1>
      <div className="container-fluid text-center p-0">
        <div className="row g-3">
          {infos.map((info: IInfos, key: number) => (
            <div
              className="infotek col-sm-12 col-md-6 col-lg-4"
              onClick={() => setInfo(info)}
              key={key}
            >
              <div className="p-4 infotek-content">
                <div className="d-flex justify-content-between align-items-center">
                  <i
                    className={`bi ${info.icon}`}
                    style={{ fontSize: "30px" }}
                  />
                  <i className="bi bi-chevron-right" />
                </div>
                <div>{info.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal className="modal-team" show={!!info} onHide={handleClose}>
        {info && (
          <div className="d-flex flex-column justify-content-center m-4 mb-2">
            <div className="mb-1 d-flex flex-row justify-content-between">
              <div className="d-flex flex-row justify-content-start gap-2 mb-0 pb-0">
                <h4 className="short-agenda-modal mt-2 pt-2">
                  <p className="fw-bold">{info.label}</p>
                </h4>
              </div>
              <i
                className="bi bi-x-circle"
                onClick={handleClose}
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#000D5B",
                }}
              />
            </div>
            {isDesktop() && (
              <embed
                className="embed-pdf mb-2"
                src={info.pdf}
                type="application/pdf"
              />
            )}
            {!isDesktop() && (
              <Link target="_BLANK" className="link" to={info.pdf}>
                Visualisez {info.label}
              </Link>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default InfotekContainer;
